export default __webpack_public_path__ + "static/media/master.0bcd651e.png";